import React from "react"

import TeamRippleIcon from "../../../../public/assets/ripple-triskelion.svg"

interface AvatarProps {
  author: string | undefined
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InsightsAvatar: React.FC<AvatarProps> = ({ author }) => (
  <div className="flex items-center justify-center w-7 h-7 rounded-full bg-gray-80">
    <TeamRippleIcon
      title="Insight Author Avatar"
      className="w-auto h-4"
      style={{ marginLeft: "-1px" }}
    />
  </div>
)

export default InsightsAvatar
